import OneTimeAccessModal from './OneTimeAccessModal';

export default OneTimeAccessModal;
